/**
 * Created by lenovo on 2017/4/25.
 */
import React,{Component} from 'react'
import {Link} from 'react-router'
import {language,getUserId,resultTip} from 'UTIL/common'
import {errorShow, successShow} from "../../utils/common";

export default class PasswordInput extends Component{
    onChange(){
        var id = this.props.id;
        if($.trim($("#"+id).val())==''){
            errorShow(id,'信息未填写！')
        }else {
            successShow(id);
        }
    }
    render(){
        return (
            <div className="row form-group">
                <div className="col-sm-3">
                    <label>{language()[this.props.name]}</label>
                </div>
                <div className="col-sm-6">
                    <input type="password" placeholder={language()[this.props.name]} id={this.props.id}
                           className=" form-control editor edit-text " onChange={this.onChange.bind(this)}/>
                </div>
                <div  className="col-sm-3">
                    <span className = "">
                          <span id={"error_"+this.props.id}  name="success" ></span>
                          <span className = ""></span>
                    </span>
                </div>
                <p className="form-control-static text-danger">
                    <span style={{fontSize: "20px"}}>*</span>
                </p>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./modules/component/form/passwordInput.js